module.exports = __webpack_public_path__ + "img/_box_schedule.1c5b8332.svg";